














import { Component, Model, Vue } from "vue-property-decorator";
import { Action, State } from "vuex-class";

@Component({})
export default class DocumentForm extends Vue {
  @State("raw")
  private text!: string;

  @Action("updateRaw")
  private update!: (text: string) => void;
}
